import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { RoleGuard } from '@/shared/guards/RoleGuard';
import { TOTVS_INTEGRATOR_ROLES } from '@/shared/guards/roles';
import { TotvsProductLinksPage } from './pages/TotvsProductLinksPage';
import { TotvsSyncTaskDetailPage } from './pages/TotvsSyncTaskDetailPage';
import { TotvsSyncTasksPage } from './pages/TotvsSyncTasksPage';

export const totvsRoutes: RouteObject[] = [
  {
    element: <RoleGuard roles={TOTVS_INTEGRATOR_ROLES} />,
    children: [
      {
        path: 'totvs',
        children: [
          { index: true, element: <Navigate to="jobs" replace /> },
          { path: 'jobs', element: <TotvsSyncTasksPage /> },
          { path: 'jobs/:taskId', element: <TotvsSyncTaskDetailPage /> },
          { path: 'product-links', element: <TotvsProductLinksPage /> },
        ],
      },
    ],
  },
];
